import { useState } from "react";
import styles from "./FolderWindow.module.css";
import FileIcon from "./FileIcon";
import FileViewer from "./FileViewer";

const FolderWindow = ({ name, content, onClose }) => {
  const [navStack, setNavStack] = useState([{ name, content }]);
  const [navIndex, setNavIndex] = useState(0);
  const [openFile, setOpenFile] = useState(null);
  const [selectedName, setSelectedName] = useState(null);

  const current = navStack[navIndex];
  const canGoBack = navIndex > 0;
  const canGoForward = navIndex < navStack.length - 1;

  const handleOpen = (item) => {
    setSelectedName(null);
    if (item.type === "folder") {
      const newStack = [...navStack.slice(0, navIndex + 1), { name: item.name, content: item.content }];
      setNavStack(newStack);
      setNavIndex(navIndex + 1);
      setOpenFile(null);
    } else {
      setOpenFile(item);
    }
  };

  const handleNavBack = () => {
    if (canGoBack) {
      setSelectedName(null);
      setNavIndex(navIndex - 1);
    }
  };

  const handleNavForward = () => {
    if (canGoForward) {
      setSelectedName(null);
      setNavIndex(navIndex + 1);
    }
  };

  return (
    <>
      <div
        className={styles.window}
        onClick={(e) => { e.stopPropagation(); setSelectedName(null); }}
      >
        <div className={styles.toolbar}>
          <div className={styles.trafficLights}>
            <button className={`${styles.dot} ${styles.close}`} onClick={onClose} />
            <button className={`${styles.dot} ${styles.minimize}`} />
            <button className={`${styles.dot} ${styles.zoom}`} />
          </div>
          <div className={styles.navArrows}>
            <button
              className={`${styles.arrow} ${!canGoBack ? styles.arrowDisabled : ""}`}
              onClick={handleNavBack}
              disabled={!canGoBack}
            >
              ‹
            </button>
            <button
              className={`${styles.arrow} ${!canGoForward ? styles.arrowDisabled : ""}`}
              onClick={handleNavForward}
              disabled={!canGoForward}
            >
              ›
            </button>
          </div>
          <span className={styles.title}>{current.name}</span>
        </div>
        <div className={styles.content}>
          {current.content.map((item) => (
            <FileIcon
              key={item.name}
              item={item}
              isSelected={selectedName === item.name}
              onSelect={() => setSelectedName(item.name)}
              onOpen={handleOpen}
            />
          ))}
        </div>
      </div>
      {openFile && (
        <FileViewer file={openFile} onClose={() => setOpenFile(null)} />
      )}
    </>
  );
};

export default FolderWindow;
